"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BookOutline = {
  name: 'book',
  theme: 'outline',
  icon: {
    tag: 'svg',
    attrs: {
      viewBox: '64 64 896 896'
    },
    children: [{
      tag: 'path',
      attrs: {
        d: 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z'
      }
    }]
  }
};
exports.default = BookOutline;